import { MY_CART_COLOR, MY_PURCHASED_COLOR, PARTIALY_BOOKED_COLOR } from "../../../shared/Modals/PurchaseTokenModal/purchaseTokenModal.data";
import Zone1 from "./ZoneAreas/Zone1";

export const MIN_SCALE = 0.3;
export const MAX_SCALE = 5;
export const SWITCH_SCALE = 1;
export const MAX_ZOOM_SCALE = 1.8;
export const DEFAULT_W = 1665; // 1315 + 175 padding on each side
export const DEFAULT_H = 750;

export const courtPlayerActionImagesForZones = [
  { zone: 1, x: 26, y: 276, xOffset: 0, yOffset: 0 },
  { zone: 2, x: 82, y: 133, xOffset: 0, yOffset: 0 },
  { zone: 3, x: 82, y: 418, xOffset: 0, yOffset: 0 },
  { zone: 4, x: 97, y: 88, xOffset: 80, yOffset: -100 },
  { zone: 5, x: 97, y: 463, xOffset: 45, yOffset: 55 },
  { zone: 6, x: 425, y: 21, xOffset: 0, yOffset: 0 },
  { zone: 7, x: 425, y: 276, xOffset: 0, yOffset: 0 },
  { zone: 8, x: 425, y: 530, xOffset: 0, yOffset: 0 },
  { zone: 9, x: 691, y: 530, xOffset: 0, yOffset: 0 },
  { zone: 10, x: 691, y: 276, xOffset: 0, yOffset: 0 },
  { zone: 11, x: 691, y: 21, xOffset: 0, yOffset: 0 },
  { zone: 12, x: 1020, y: 463, xOffset: -45, yOffset: 55 },
  { zone: 13, x: 1020, y: 88, xOffset: -80, yOffset: -100 }, 
  { zone: 14, x: 1034, y: 418, xOffset: 0, yOffset: 0 },
  { zone: 15, x: 1034, y: 133, xOffset: 0, yOffset: 0 },
  { zone: 16, x: 1090, y: 276, xOffset: 0, yOffset: 0 },
];

// Note: You will need to update in sportCourtConfig.js file
export const zoneCatByZoneArea = {
  1: ["1", "2", "3", "14", "15", "16"], // Platinum $100
  2: ["4", "5", "12", "13"],           // Gold $70
  3: ["6", "7", "8", "9", "10", "11"], // Silver $40
};

export const getDefaultZoneName = (zoneCategories, zoneName) => {
  if (!zoneCategories) return null;

  // Create the flat-mapped data
  const zoneCategoryData = zoneCategories?.flatMap((x, index) => {
    const ele = x?.zones?.flat();
    return ele?.map((ele, _ind) => ({
      ...ele,
      zoneCategory: index,
      newZoneName: zoneCatByZoneArea[index + 1][_ind],
    }));
  });

  // Find the matching zoneName and return its newZoneName
  const matchingZone = zoneCategoryData?.find((z) => z.zoneName === zoneName);
  return matchingZone?.newZoneName || null;
};

export const getZoneCatByZoneArea = (zoneArea) => {
  let zoneCat = null;
  Object.entries(zoneCatByZoneArea).forEach(([key, value]) => {
    if (value.includes(zoneArea)) {
      zoneCat = key;
    }
  });

  return zoneCat;
};

// prices for each zone category
export const zoneDataByZoneCat = (zoneCat, zoneCategories) => {
  if (!zoneCategories) return;

  switch (zoneCat) {
    case "1":
      return zoneCategories[0];
    case "2":
      return zoneCategories[1];
    case "3":
      return zoneCategories[2];
    default:
      return;
  }
}

// get tokenColor based on zoneCategory
export const getMyTokenFill = (zoneCat) => {
  // fill = {
  //   path1: "#B2A5FF",
  //   path2: "#9381FF",
  //   path3: "#A495FF",
  //   circle: "#A697FF"
  // }

  if (zoneCat === 1) {
    return {
      path1: "#B2A5FF",
      path2: "#9381FF",
      path3: "#A495FF",
      circle: "#A697FF"
    }
  } else if (zoneCat === 3) {
    return {
      path1: "#FC780B",
      path2: "#EF4E16",
      path3: "#FFAD02",
      circle: "#F1AD02"
    }
  } else {
    return {
      path1: "#99C9FF",
      path2: "#56A6FF",
      path3: "#C9E2FE",
      circle: "#D1E2FE"
    }
  }
}

export const myTokens = [
  {
    id: 1,
    zoneCategory: 1,
    position: {
      x: 400,
      y: 450,
      dataX: 500,
      dataY: 510
    },
  },
  // {
  //     id: 2,
  //     zoneCategory: 2,
  //     position: {
  //         x: 500,
  //         y: 300,
  //         dataX: 500,
  //         dataY: 300
  //     },
  // },
  // {
  //     id: 3,
  //     zoneCategory: 3,
  //     position: {
  //         x: 900,
  //         y: 200,
  //         dataX: 900,
  //         dataY: 200
  //     },
  // }
]

export const purchasedTokens = [
  {
    id: 1,
    zoneCategory: 1,
    position: {
      x: 500,
      y: 450,
      dataX: 500,
      dataY: 300
    },
  },
]

export const Zones = [
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
  Zone1,
]

export const mapZoneCatNumberToZoneCatName = {
  "1": "Zone A",
  "2": "Zone B",
  "3": "Zone C",
  "4": "Zone D",
  "5": "Zone E",
  "6": "Zone F",
  "7": "Zone G",
  "8": "Zone H",
  "9": "Zone I",
  "10": "Zone J",
  "11": "Zone K",
  "12": "Zone L",
  "13": "Zone M",
  "14": "Zone N",
  "15": "Zone O",
  "16": "Zone P",
}

export const DISABLED_DATA = {
  myPurchasedForMatch: "data-myPurchasedForMatch",
  myPurchasedForSeason: "data-myPurchasedForSeason",
  myBookedForMatch: "data-myBookedForMatch",
  myBookedForSeason: "data-myBookedForSeason",
  purchasedByOtherForMatch: "data-purchasedByOtherForMatch",
  purchasedByOtherForSeason: "data-purchasedByOtherForSeason",
  disableColorSwitch1: "data-disableColorSwitch1",
  disableColorSwitch2: "data-disableColorSwitch2",
  disableColorSwitch3: "data-disableColorSwitch3",
  disabled: "data-disabled",
  selected: "selected",
}

// extract x and y coordinates
// export const extractCoordinates = (matrix) => {
//   const values = matrix.match(/matrix\(([^)]+)\)/)[1].split(" ");

//   const x = parseFloat(values[4]);
//   const y = parseFloat(values[5]);

//   return { x, y };
// };


// clear all selections
export const cleanAllSelection = (rect) => {
  // we are checking for each cube if have some data attribute which we are using to disable
  if (rect.getAttribute(DISABLED_DATA.disableColorSwitch1)) {
    // clear extra fills and remove selection
    rect.style.fill = MY_PURCHASED_COLOR
    // rect.removeAttribute(DISABLED_DATA.selected)
  } else if (rect.getAttribute(DISABLED_DATA.disableColorSwitch2)) {
    // clear extra fills and remove selection
    rect.style.fill = PARTIALY_BOOKED_COLOR
    // rect.removeAttribute(DISABLED_DATA.selected)
  } else if (rect.getAttribute(DISABLED_DATA.disableColorSwitch3)) {
    // clear extra fills and remove selection
    rect.style.fill = MY_CART_COLOR
    // rect.removeAttribute(DISABLED_DATA.selected)
  } else if (!(rect.getAttribute(DISABLED_DATA.disabled))) {
    // clear extra fills and remove selection
    rect.style.fill = ""
    // rect.removeAttribute(DISABLED_DATA.selected)
  }
}